// @flow

import { graphql } from 'react-relay';
import { Box } from 'react-system';
import { useScript } from '@realadvisor/hooks';
import { PageMeta } from '../shared/prismic/PageMeta';
import { useLocale } from '../hooks/locale.js';
import { type NextQuery, nextQuery } from '../controls/relay';
import { MuiThemeProvider } from '../controls/mui-providers';
import { Layout } from '../shared/Layout.js';
import { SectionHeading } from '../controls/section-heading';
import { JoinReasonsSection } from '../shared/join-reasons-section.js';
import { RedOrBluePillSection } from '../shared/red-or-blue-pill-section.js';
import type { jobsQuery } from './__generated__/jobsQuery.graphql.js';

const WORKABLE_KEY = 237661;

const Jobs = props => {
  const { t } = useLocale();
  const state = useScript('https://www.workable.com/assets/embed.js');
  return (
    <Layout
      root={props.data}
      pageWithData={props.data.cms.pageWithData}
      headerStyle="normal"
    >
      <MuiThemeProvider>
        <PageMeta root={props.data} />
        <Box mt={[3, 6]} />
        <SectionHeading align="center">{t('jobs')}</SectionHeading>
        <Box mb={6}>
          <div css={{ textAlign: 'center' }} id="whr_embed_hook" />
        </Box>
        <JoinReasonsSection />
        <RedOrBluePillSection />
        {state === 'done' &&
          window.whr_embed(WORKABLE_KEY, {
            detail: 'titles',
            base: 'jobs',
            zoom: 'city',
            grouping: 'none',
          })}
      </MuiThemeProvider>
    </Layout>
  );
};

const JobsPage: NextQuery<
  jobsQuery,
  {| lang?: string, uid?: string |},
> = nextQuery(ctx => ({
  query: graphql`
    query jobsQuery($uid: String!, $lang: String!) {
      ...Layout_root @arguments(lang: $lang)
      ...PageMeta_root
      cms {
        pageWithData(uid: $uid, lang: $lang) {
          ...Layout_pageWithData
        }
      }
    }
  `,
  variables: {
    uid: ctx.query.uid ?? '',
    lang: ctx.query.lang ?? '',
  },
  cacheStrategy: 'cache-only',
}))(Jobs);

export default JobsPage;
